export const API_FAILURE_NOTIFICATION = 'API_FAILURE_NOTIFICATION'
